import { useEffect } from 'react';
import { authApi } from '../api/auth-api';
import { useAuthStore } from '../model/auth-store';

/** Validates a persisted token once at startup; logs out silently if it expired. */
export function AuthBootstrap() {
  useEffect(() => {
    const token = useAuthStore.getState().accessToken;
    if (!token) return;
    authApi
      .verifyToken(token)
      .then((valid) => {
        if (!valid) useAuthStore.getState().logout();
      })
      .catch(() => {
        /* offline / server hiccup: keep the session, requests will 401 if truly invalid */
      });
  }, []);
  return null;
}
